module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_div.a0b7204b.png";